import Cookies from 'js-cookie'
import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Xui from 'xui'
import ElementUI from 'element-ui'
import '@/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import * as filters from './filters'
import mixins from './mixins'

import '@/icons' // icon
import '@/permission' // permission control
import '@/utils/error-log' // error log

import './single-spa-config.js'

// 引入全局组件
Vue.use(Xui)
// set ElementUI lang to EN
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale,
})

// 注册全局过虑器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 注册全局 mixins.
Vue.mixin(mixins)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
